export default __webpack_public_path__ + "static/media/str_alpha.6a3fb19e.jpg";